import state from './urlShareState';
import mutations from './urlShareMutations';
import getters from './urlShareGetters';
import actions from './urlShareActions';

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
